<template>
  <div v-if="datalist.length > 0">
    <div class="gl_listWrapBar"
         v-for="(item, index) in datalist"
         :key="index">
      <div class="gl_imgList"
           @click="clkNews(item)">
        <img :src="item.slideShow"
             width="156"
             height="88" />
      </div>
      <a href="javascript:;"
         class="gl_listItem">
        <div class="gl_listItemTitle"
             @click="clkNews(item)">
          {{ ellipsis(item.title, 48) }}
        </div>
        <div class="gl_listItemSub"
             @click="clkNews(item)">
          {{ ellipsis(textFormat(item.contents), 48) }}
        </div>
        <div class="display_between marginTop10">
          <div v-if="item.labelName != ''">
            <span v-bind:class="calculate(indexn)"
                  v-for="(qitem, indexn) in (item.labelName || '').split(',')"
                  :key="indexn"
                  @click="onsearch(qitem)">{{ qitem }}</span>
          </div>
          <div v-else></div>
          <div class="gl_inforshow">
            <span class="marginRight20">{{ formatTime(item.publishtime, 'YYYY/MM/DD') }}</span>
            <span>
              <img src="/image/index/chakan.png" />
              {{ item.clickVolume }}人
            </span>
          </div>
        </div>
      </a>
    </div>
  </div>
  <div v-else-if="datalist.length == 0 && ishow">暂无数据</div>
</template>

<script>
import format from '@/assets/unit/unit.js';
export default {
  name: 'ShInforList',
  props: {
    datalist: {
      type: Array,
    },
    ishow: {
      type: Boolean,
      // default: false,
    },
  },
  data () {
    return {
      apiData: [],
      colorList: ['gl_gree_block', 'gl_red_block', 'gl_blue_block'],
    };
  },
  created () {
    // this.getData()
  },
  methods: {
    onsearch (keywords) {

      const { href } = this.$router.resolve({
        path: 'searchPage?',
        query: {
          labelname: keywords,
          tagIndexmuber: 'ShInforList',
        },
      });
      window.open(href, '_blank');
    },
    /**新闻的点击事件 */
    clkNews (info) {
      //如果外连接存在，跳转外链，否则跳转详情
      if (Object.keys(info.address).length == 0) {
        const { href } = this.$router.resolve({
          path: '/home/inforDetails?',
          query: {
            id: info.id,
            column_Type: info.cid,
          },
        });
        window.open(href, '_blank');
      } else {
        let urlstr = info.address;
        let param = urlstr.substr(urlstr.indexOf('?'), urlstr.length - urlstr.indexOf('?'));
        if (urlstr.search('magazine/magazinejournal/magazinejournaldetail') > -1) {
          const { href } = this.$router.resolve({
            path: 'litedetails?' + param,
          });
          window.open(href, '_blank');
        } else {
          // window.open(info.address);
          this.httphelper
            .post('/api/NewApi/UpdNewInfoClickCount', {
              Id: info.id
            })
            .then(res => {
              if (res.data.code == 200) {
              } window.open(info.address);
            });
        }
      }
    },
    calculate (index) {
      var nm = this.colorList[Math.floor(index % 3)];
      return nm;
    },
    filterHtml (value) {
      return value
        .replace(/<[^>]+>/g, '')
        .replace(/\s+/g, '')
        .replace(/&emsp;/g, '');
    },
    formatTime (datatime, timeformat) {
      return format(datatime, timeformat);
    },
    getData () {
      var that = this;
      fetch('/data.json')
        .then(res => {
          return res.json();
        })
        .then(data => {
          that.apiData = data.ShInforList.data;
        })
    },
    textFormat (val) {
      if (val) {
        return val
          .replace(/<[^>]+>/g, '')
          .replace(/&mdash;/g, '')
          .replace(/&ldquo;/g, '')
          .replace(/&rdquo;/g, '')
          .replace(/&gamma;/g, '')
          .replace(/&beta;/g, '')
          .replace(/#br#/g, '')
          .replace(/&quot;/g, '')
          .replace(/&kappa;/g, '')
          .replace(/&nbsp;/g, '')
          .replace(/&emsp;/g, '');
      }
    },
  },
};
</script>

<style scoped></style>
